export default __webpack_public_path__ + "a3f3bddd0816f511a4d57fd1317c3b65.svg";